<template>
  <el-row>
    <el-col :span="24">
      <div class="grid-content padding-top padding-bottom">
        <el-card class="box-card margin-bottom" shadow="never">
          <slot name="filters"></slot>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :xl="8">
              <slot name="inline-filters">&nbsp;</slot>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="16">
              <div class="filter-box">
                <a class="filter-btn text-grey" v-popover:sortPopup>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="filter-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5" />
                  </svg>
                  <el-popover ref="sortPopup" placement="bottom" width="500" trigger="click">
                    <div class="sort-popup">
                      <el-table :data="dataSorts" style="width: 100%" :show-header="false" :border="false">
                        <el-table-column>
                          <template slot-scope="scope">
                            {{ scope.row.name }}
                          </template>
                        </el-table-column>
                        <el-table-column width="250">
                          <template slot-scope="scope">
                            <el-radio-group v-model="dataSorted[scope.row.key]" @change="fetchData">
                              <el-radio label=""><span class="text-black">Không</span></el-radio>
                              <el-radio :label="1"><span class="text-blue">Tăng</span></el-radio>
                              <el-radio :label="-1"><span class="text-red">Giảm</span></el-radio>
                            </el-radio-group>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-popover>
                </a>
                <a href="#" @click.prevent="removeFilter" class="filter-btn text-red">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="filter-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                  </svg>
                </a>
                <el-input size="small" class="filter-search-box" :placeholder="searchText" prefix-icon="el-icon-search"
                  v-model="q" @input="filter">
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <slot name="batch_actions"></slot>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <div class="block pull-right margin-top" v-if="(typeof dataPaginations[tableName] !== 'undefined')">
                <el-pagination layout="sizes, prev, pager, next" background :page-sizes="[25, 50, 100, 200]"
                  :current-page="dataPaginations[tableName].current_page" :page-size="dataPaginations[tableName].per_page"
                  :total="dataPaginations[tableName].total" @current-change="pageChange" @size-change="handleSizeChange">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <slot :data="dataTable"></slot>
        <div class="block pull-right margin-top" v-if="(typeof dataPaginations[tableName] !== 'undefined')">
          <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[25, 50, 100, 200]"
            :current-page="dataPaginations[tableName].current_page" :page-size="dataPaginations[tableName].per_page"
            :total="dataPaginations[tableName].total" @current-change="pageChange" @size-change="handleSizeChange">
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce, forEach, findIndex, clone, isEmpty } from 'lodash'
import ls from 'local-storage'

export default {
  name: 'gs-table',
  props: {
    tableName: {
      type: String,
      default: 'anonymous'
    },
    dataSource: {
      type: String,
      default: null
    },
    dataParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dataSorted: {
      type: Object,
      default: () => {
        return {
          created_at: -1
        }
      }
    },
    dataSorts: {
      type: Array,
      default: () => {
        return [
          { key: 'created_at', name: 'Ngày tạo' }
        ]
      }
    },
    searchText: {
      type: String,
      default: 'Tìm kiếm'
    },
    cacheData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      q: null,
      sortStatus: '',
      lastParams: {}
    }
  },
  computed: {
    ...mapGetters('gsTable', ['dataTable', 'dataTables', 'dataPaginations', 'tableQueries']),
  },
  methods: {
    ...mapActions('gsTable', ['fetchTableData', 'setTableData', 'setPaginator', 'setTableQuery']),
    fetchData() {
      this.sort()
      if (!isEmpty(this.$route.query)) {
        this.$router.push({ query: { ...this.$route.query, ...this.dataParams, q: this.q, sort: this.dataParams.sort, limit: this.dataParams.limit } })
      }

      this.dataParams.limit = (!isEmpty(this.$route.query) && this.$route.query.limit !== '') ? this.$route.query.limit : 25
      this.dataParams.q = this.tableQueries[this.tableName] ? this.tableQueries[this.tableName] : (!isEmpty(this.$route.query) && this.$route.query.q !== '') ? this.$route.query.q : null
      if (JSON.stringify(this.dataParams) !== JSON.stringify(this.lastParams)) {
        this.dataParams.page = !isEmpty(this.$route.query) ? Number(this.$route.query.page) : 1
        if (typeof this.dataPaginations[this.tableName] !== 'undefined') {
          if (this.dataParams.page === this.lastParams.page) {
            this.dataParams.page = 1
          }
          this.setPaginator({ table_name: this.tableName, key: 'current_page', value: this.dataParams.page })
        }
      } else if (typeof this.dataPaginations[this.tableName] !== 'undefined') {
        this.dataParams.page = this.dataPaginations[this.tableName].current_page
      }

      this.fetchTableData({
        url: this.dataSource,
        params: this.dataParams,
        table_name: this.tableName
      })

      this.lastParams = clone(this.dataParams)
    },
    filter: debounce(function () {
      if (this.q !== this.tableQueries[this.tableName]) {
        this.setTableQuery({ table_name: this.tableName, value: this.q })
        this.fetchData()
      }
    }, 500),
    sort() {
      let sort = ''
      forEach(this.dataSorted, (value, key) => {
        if (value) {
          sort += `${key}:${value},`
        }
      })
      if (sort.slice(0, sort.length - 1)) {
        this.dataParams.sort = sort.slice(0, sort.length - 1)
      }
      let lsSorteds = ls.get('sorteds', {})
      if (!lsSorteds) {
        lsSorteds = {}
      }
      lsSorteds[this.tableName] = this.dataSorted
      ls.set('sorteds', lsSorteds)
    },
    removeFilter() {
      this.setTableQuery({ table_name: this.tableName, value: null })
      this.q = null
      this.$emit('remove-filter')
    },
    pageChange(page) {
      this.setPaginator({ table_name: this.tableName, key: 'current_page', value: page })
      if (this.dataParams.page !== page) {
        this.dataParams.page = page
        if (isEmpty(this.$route.query)) {
          this.$router.push({ query: { ...this.$route.query, ...this.dataParams } })
        }
        this.fetchData()
      }
    },
    handleSizeChange(value) {
      this.setPaginator({ table_name: this.tableName, key: 'per_page', value })
      this.dataParams.limit = value
      if (isEmpty(this.$route.query)) {
        this.$router.push({ query: { ...this.$route.query, ...this.dataParams } })
      }
      this.fetchData()
    }
  },
  mounted() {
    this.q = !isEmpty(this.$route.query) ? this.$route.query.q : null
    if (!isEmpty(this.$route.query)) {
      if (isEmpty(this.$route.query.sort)) {
        forEach(this.dataSorts, (val) => {
          this.dataSorted[val.key] = ''
        })
      } else {
        const pairs = this.$route.query.sort.split(',')
        forEach(pairs, (val) => {
          const [key, valueStr] = val.split(':')
          const trimmedKey = key.trim()
          this.dataSorted[trimmedKey] = Number(valueStr)
        })
      }
    }
    if (this.cacheData) {
      if (typeof this.dataTables[this.tableName] === 'undefined') {
        this.fetchData()
      } else {
        this.setTableData(this.tableName)
        this.q = this.tableQueries[this.tableName] ? this.tableQueries[this.tableName] : null
      }
    } else {
      this.fetchData()
    }
  },
  created() {
    this.$on('reload-table', (reset) => {
      if (typeof this.dataPaginations[this.tableName] !== 'undefined' && reset) {
        this.setPaginator({ table_name: this.tableName, key: 'current_page', value: 1 })
      }
      if (typeof this.dataTables[this.tableName] !== 'undefined') {
        this.fetchData()
      }
    })
  },
  watch: {
    dataSorted: {
      handler: function (value) {
        let sortTxt = ''
        forEach(this.dataSorted, (value, key) => {
          if (value) {
            if (findIndex(this.dataSorts, { key: key }) > -1) {
              sortTxt += this.dataSorts[findIndex(this.dataSorts, { key: key })]['name'] + `: ${value === 1 ? 'tăng' : 'giảm'}, `
            } else {
              sortTxt += `${key}: ${value === 1 ? 'tăng' : 'giảm'}, `
            }
          }
        })
        this.sortStatus = sortTxt.slice(0, sortTxt.length - 2)
      },
      deep: true
    },
    selectedRows(val) {
      console.log(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// GsTable.vue?14f9d364